import { NodeRendererProps } from 'react-arborist';
import { Box, Chip, IconButton, styled, Tooltip, Typography } from '@mui/material';
import Iconify from 'src/components/iconify';

export const NodeItem = ({ node, style, dragHandle }: NodeRendererProps<any>) => {
  return (
    <StyledNodeContainer
      style={style}
      ref={dragHandle}
      onClick={() => node.isInternal && node.toggle()}
      useYn={node.data.useYn}
    >
      {/* 왼쪽 섹션: 드래그 핸들과 아이콘 */}
      <LeftSection>
        <StyledDragHandle icon="mdi:drag-horizontal" className="drag-handle" />
        <Iconify
          icon={node.data.isBusiness ? 'material-symbols:note-outline' : 'mdi:folder-outline'}
          color={node.data.isBusiness ? 'error.main' : 'primary.main'}
          sx={{ ml: 1 }}
        />
      </LeftSection>
      <CenterSection>
        <Typography
          style={{
            color: node.data.isBusiness ? 'text.secondary' : 'text.primary',
            fontWeight: node.data.isBusiness ? 400 : 500,
          }}
        >
          {node.data.name}
        </Typography>
        {/* 내부 노드 토글 버튼 */}
        {node.isInternal && (
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              node.toggle();
            }}
          >
            {node.data.children?.length > 0 && (
              <StyledChildCount>({node.data.children.length})</StyledChildCount>
            )}
          </IconButton>
        )}
      </CenterSection>
      {/* 오른쪽 섹션: 상태 표시 */}
      <RightSection>
        <Tooltip title={node.data.useYn ? '사용 중' : '미사용'}>
          <StyledStatusChip
            size="small"
            label={node.data.useYn ? '사용' : '미사용'}
            color={node.data.useYn ? 'error' : 'default'}
            variant="outlined"
          />
        </Tooltip>
      </RightSection>
    </StyledNodeContainer>
  );
};

const StyledNodeContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'useYn',
})<{ useYn: boolean }>(({ theme, useYn }) => ({
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  gap: 8,
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: 5,
  backgroundColor: 'background.paper',
  opacity: useYn ? 1 : 0.7,
  '&:hover .drag-handle': {
    opacity: 1,
  },
}));

const StyledDragHandle = styled(Iconify)({
  opacity: 0.3,
  cursor: 'grab',
  marginX: 1,
  marginLeft: 10,
  '&:hover': { opacity: 1 },
});

const StyledChildCount = styled(Typography)({
  variant: 'caption',
  color: 'text.disabled',
});

const StyledStatusChip = styled(Chip)({
  height: 20,
  fontSize: '0.75rem',
});

const LeftSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  minWidth: '80px',
  justifyContent: 'center',
});
const CenterSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  flex: 1,
  padding: '0 16px',
});
const RightSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '80px',
});
